import { Slot } from '@radix-ui/react-slot'
import { useTranslation } from 'react-i18next'
import { toast } from 'sonner'

import { useWithAffectedOGsHandler } from '@/entities/optimization-group'
import { useSetMainGlobalPcSetMutation } from '@/entities/pricing-campaign'

import { confirm } from '@/shared/components/ui/confirmer'
import { ampli } from '@/shared/lib/ampli'
import { queryClient } from '@/shared/lib/query-client'

export const SetGlobalPcSetAsMain = ({
	children,
	id,
	name,
}: {
	children: React.ReactNode
	id: string
	name: string
}) => {
	const { t } = useTranslation()

	const baseSetMainGlobalPcSetMutation = useSetMainGlobalPcSetMutation({
		onSuccess: () => {
			queryClient.invalidateQueries({
				queryKey: ['global-pc-sets-list'],
			})
			queryClient.invalidateQueries({
				queryKey: ['global-pc-set'],
			})
			queryClient.invalidateQueries({
				queryKey: ['pricing-campaigns'],
			})
			queryClient.invalidateQueries({
				queryKey: ['pricing-campaigns-overview'],
			})
		},
	})
	const setMainGlobalPcSetMutation = useWithAffectedOGsHandler(
		baseSetMainGlobalPcSetMutation
	)
	const handleApplyGlobalSetAsMain = async () => {
		const answer = await confirm({
			title: t('global_set.set_main.confirm.title', {
				defaultValue: 'Apply as Main Set?',
			}),
			description: t('global_set.set_main.confirm.text', {
				name,
				defaultValue: `Are you sure you want to apply ${name} as the main set? This will affect all optimization groups that contains global Pricing campaign set, and move them to 'Ready to start' status`,
			}),
			actionText: t('general_apply', { defaultValue: 'Apply' }),
			cancelText: t('general_cancel', { defaultValue: 'Cancel' }),
		})
		if (!answer) {
			return
		}

		/**
		 * The 424 handler automatically intercepts and handles affected optimization groups.
		 * No manual pre-check needed - backend is source of truth.
		 */
		ampli.globalPcSetActionClicked({
			global_pc_set_action: 'promote',
		})
		toast.promise(setMainGlobalPcSetMutation.mutateAsync(id), {
			loading: t('global_set.set_main.proccess', {
				defaultValue: `Applying ${name} as main...`,
			}),
			success: t('global_set.set_main.success', {
				name,
				defaultValue: `${name} set successfully set as main`,
			}),
			error: t('global_set.set_main.error', {
				name,
				defaultValue: `Error while setting ${name} as main`,
			}),
		})
	}

	return <Slot onClick={handleApplyGlobalSetAsMain}>{children}</Slot>
}
